import { render, staticRenderFns } from "./AlertsList.vue?vue&type=template&id=5f21ad91&"
import script from "./AlertsList.vue?vue&type=script&lang=js&"
export * from "./AlertsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports